exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".smaller-column{width:5%}.v-data-table /deep/ thead tr th{background-color:red!important}.notMatchingSlot{color:red}", ""]);

// exports
